import "./src/styles/global.scss"
import LogRocket from 'logrocket'

export const onClientEntry = () => {
  window.ga = window.ga || (() => null)
  LogRocket.init('4z9u1h/graphup')
}
